module.exports = __webpack_public_path__ + "media/images/lb/366-b8ee63d4d2dd21dd91aa35ab27c68120.svg";